"use strict";

export var FormFilterConstants = {
  FORM_FILTER_INITIALIZE: 'FORM_FILTER_INITIALIZE',
  FORM_FILTER_NAVIGATE_TO_PARENT: 'FORM_FILTER_NAVIGATE_TO_PARENT',
  FORM_FILTER_APPLY: 'FORM_FILTER_APPLY',
  FORM_FILTER_UPDATE: 'FORM_FILTER_UPDATE'
};